export default function initTooltips($selector) {
    $selector.tooltip();
}
